import { Application } from 'pixi.js';

import { startGame } from './game/game';
import './styles/main.scss';

const BACKGROUND: number = 0x0b0e14;

const host: HTMLElement | null = document.querySelector<HTMLElement>('#stage');
if (host === null) {
  throw new Error('Не найден контейнер #stage');
}

const app: Application = new Application();

await app.init({
  background: BACKGROUND,
  // Полноэкранный канвас: Pixi сам пересчитывает размер бэкбуфера при ресайзе окна.
  resizeTo: window,
  antialias: true,
  autoDensity: true,
  resolution: window.devicePixelRatio,
  preference: 'webgpu',
});

host.appendChild(app.canvas);

await startGame(app);
